import { graphql } from 'react-relay';

import useMutation from '@zego/mutations/useMutation';

const mutation = graphql`
  mutation useCarEstimateResultMutation($input: CarPriceEstimate2Input!) {
    result: getCarPriceEstimate2(input: $input) {
      estimateResult {
        state
        ...CarQuickEstimatesGbContainer_estimateResult
      }
    }
  }
`;

export default function useCarEstimateResult() {
  return useMutation(mutation);
}
